export default "__VITE_ASSET__U6ta7gzJ__"